import fn from './fn.js';

const isElement = function (value) {
    return value.tagName;
};
const isInput = function (value) {
    return /input/i.test(value.tagName);
};
const isSelect = function (value) {
    return /select/i.test(value.tagName);
};
const isFunction = function (value) {
    return typeof value === 'function';
};
const isString = function (value) {
    return typeof value === 'string';
};
const isBoolean = function (value) {
    return typeof value === 'boolean';
};
const isNumber = function (value) {
    return typeof value === 'number' && !isNaN(value);
};
const isArray = function (value) {
    return Object.prototype.toString.call(value) === '[object Array]';
};
const isEventHub = function (value) {
    return isFunction(value.publish) && isFunction(value.subscribe);
};

const check = function (expected, predicate) {
    return function (name, key, value) {
        if (!predicate(value)) {
            throw new TypeError(`${name} requires '${key}' to be ${expected}, but was: ${value}`);
        }
    };
};

const checkers = {
    object() {},
    element: check('DOM element', isElement),
    input: check('input element', isInput),
    select: check('select element', isSelect),
    function: check('function', isFunction),
    string: check('string', isString),
    number: check('number', isNumber),
    list: check('list', isArray),
    eventHub: check('eventHub', isEventHub),
    boolean: check('boolean', isBoolean),
};

const validateExistingChecker = function (val) {
    if (!checkers[val]) {
        throw new TypeError(`preconditions: unknown checker '${val}'`);
    }
};

export default function (name, requirements) {
    fn.forEach(fn.values(requirements), validateExistingChecker);
    const keys = fn.keys(requirements);

    function checkKeys(params) {
        fn.forEach(keys, (key) => {
            if (typeof params[key] === 'undefined') {
                throw new TypeError(`${name} requires '${key}' param`);
            }
            const checker = checkers[requirements[key]];
            checker(name, key, params[key]);
        });
    }

    const paramsPreconditions = function (params) {
        if (!params) {
            throw new TypeError(`${name} requires params object, but was: ${params}`);
        }
        checkKeys(params);
    };

    const argsPreconditions = function (...args) {
        if (args.length < requirements.length) {
            throw new TypeError(`${name} requires ${requirements.length} argument(s), but was: ${args.length}`);
        }
        checkKeys(args);
    };

    return isArray(requirements) ? argsPreconditions : paramsPreconditions;
}
